import React, { useEffect, useState } from "react";
import "./LoanProductsAssignedTable.scss";
import {
  TableHead,
  TableBody,
  Table,
  TableContainer,
  TableCell,
  TableRow,
  Box,
  Pagination,
  Button,
  FormControl,
  Autocomplete,
  TextField,
  Typography,
  IconButton,
  MenuItem,
  Menu,
  TablePagination,
  Modal,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions
} from "@mui/material";

import { tableCellClasses } from "@mui/material/TableCell";
import { styled } from "@mui/material/styles";
import LoadingPage from "../UI/LoadingPage/LoadingPage";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { loanLimitEdit } from "../../util/API/loans";
import CloseIcon from "@mui/icons-material/Close";
import CustomLoansForm from "../UI/CustomLoansForm/CustomLoansForm";
import BaseDrawer from "../UI/BaseDrawer/BaseDrawer";

const LoanProductsAssignedTable = ({ setCreateNewLoan, setLoanAssignment, productsAssignedToUsers, handleLoanOptOut, handleMoreInfo, setSelectedProductLoan, setSelectedProductLoanId, handleApproveLoans, handleApprovedLoans, setPayments, setAlert, setAlertOpen, getProductsAssignedToUsers, setLoanType, handleLoanOptIn, setViewCancelPayments, setViewPayments, setSelectedCurrencyCode, setViewLimitHistory, setViewCancelledLoans, setViewPreQualificationScreening, setViewUnderwritingCreditAssessment, setViewApprovalLoanRequest, setViewLoanRequestDisbursement, setSelectedLoanProductArray }) => {
  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      // backgroundColor: "rgba(0,0,0, .1)",
      color: theme.palette.common.black,
      fontWeight: "bold",
      textAlign:"left"
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 25,
      fontWeight: "600",
    },
  }));

  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [editLimitModal, setEditLimitModal] = useState(false);
  const [newLimit, setNewLimit] = useState(null);
  const [comment, setComment] = useState(null);
  const [formValues, setFormValues] = useState(null);
  const [selectedLoanProduct, setSelectedLoanProduct] = useState(null);
  const [openDetailsDialog, setOpenDetailsDialog] = useState(false);
  const [openDetailsDrawer, setOpenDetailsDrawer] = useState(false);
  
  const handleMenuOpen = (event, row) => {
    setAnchorEl(event.currentTarget);
    setSelectedRow(row);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedRow(null);
  };

  const handleViewDetails = (type, row) => {
    console.log("handleViewDetails------------", row);
    setSelectedLoanProduct(row);
    // setOpenDetailsDialog(true);
    setOpenDetailsDrawer(true);
    // handleMenuClose(); // close the menu
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0); // Reset to first page when rows per page changes
  };

  const handleEditLoanLimit = async(submittedValue) => {
    try {
      console.log("submittedValue----------", submittedValue);
      console.log("comment----------", comment);
      console.log("newLimit----------", newLimit);
      console.log("selectedRow----------", selectedRow);
      const response = await loanLimitEdit("", selectedRow?.loanlimits?.userid, selectedRow?.loanlimits?.productcode, submittedValue?.newlimit, 1);
      console.log("handleEditLoanLimit_response----------", response);
      if(response?.data?.header?.callStatus == "1") {
        getProductsAssignedToUsers();
        handleMenuClose();
        setEditLimitModal(false);
        setAlert({
          showAlert: true,
          severity: "success",
          message: "Loan Limit updated successfully",
          header: "Congratulations!"
        });
        setAlertOpen(true);
      } 
    } catch (error) {
      console.log("newLimit_error----------", error);
    }
  }

  return (
    <Box className="mt-4">
      <Typography
        sx={{
          fontFamily: "'Nunito'",
          fontStyle: "normal",
          fontWeight: 500,
          fontSize: "21.4825px",
          color: "#3A3A3A",
          paddingLeft: "1em"
        }}
        className="mb-2"
      >
        List of Assigned Loan Products
      </Typography>

      <Box sx={{ width: "100%", overflowX: "auto" }}>
        <TableContainer className="">
          <Table>
            <TableHead>
              <TableRow>
                <StyledTableCell>Product ID</StyledTableCell>
                <StyledTableCell>Currency Code</StyledTableCell>
                <StyledTableCell>Loan Product Name</StyledTableCell>
                <StyledTableCell>Status</StyledTableCell>
                <StyledTableCell>Loans Issued</StyledTableCell>
                <StyledTableCell sx={{ textAlign: "right !important" }}>Eligible Limit</StyledTableCell>
                <StyledTableCell sx={{ textAlign: "center !important" }}>Action</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {productsAssignedToUsers && productsAssignedToUsers.length > 0 ? (
                productsAssignedToUsers
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => (
                  <TableRow key={row?.loanlimits?.productcode}>
                    <TableCell align="left" className="">
                      <div>{row?.loanlimits?.productcode}</div>
                    </TableCell>
                    <TableCell align="left" className="">
                      <div>{row?.loanproducts?.currencycode}</div>
                    </TableCell>
                    <TableCell align="left" className="">
                      <div>{row?.loanproducts?.productname}</div>
                    </TableCell>
                    <TableCell align="left" className="">
                      <div>{row?.loanlimits?.status == "1" ? "Eligible" : row?.loanlimits?.status == "2" ? "Not Eligible" : row?.loanlimits?.status == "3" ? "Flagged" : row?.loanlimits?.status == "4" ? "Blocked" : "" }</div>
                    </TableCell>
                    <TableCell align="left" className="">
                      <div>{row?.loanlimits?.loanissuedcount}</div>
                    </TableCell>
                    <TableCell align="right" className="">
                      <div>{Number(row?.loanlimits?.eligiblelimit).toLocaleString("en-US", { minimumFractionDigits: 2 })}</div>
                    </TableCell>
                    <TableCell align="center">
                      <IconButton onClick={(e) => handleMenuOpen(e, row)}>
                        <MoreVertIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell align="center" colSpan={7}>
                    <Typography variant="body1" color="textSecondary">
                      No data available
                    </Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>

      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={productsAssignedToUsers.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />

      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
        <MenuItem
          onClick={() => {
            console.log("loanproducts---------",selectedRow)
            setCreateNewLoan(true);
            setSelectedProductLoan(selectedRow?.loanproducts?.productname);
            setSelectedProductLoanId(selectedRow?.loanlimits?.productcode);
            setSelectedCurrencyCode(selectedRow?.loanproducts?.currencycode);
            setSelectedLoanProductArray(selectedRow?.loanproducts);
            handleMenuClose();
            setLoanType('approval')
          }}
          disabled={selectedRow?.loanlimits?.optin == "0" ? true : false}
        >
          Create Loan Request
        </MenuItem>

        {/* <MenuItem
          onClick={() => {
            setCreateNewLoan(true);
            setSelectedProductLoan(selectedRow?.loanproducts?.productname);
            setSelectedProductLoanId(selectedRow?.loanlimits?.productcode);
            setSelectedCurrencyCode(selectedRow?.loanproducts?.currencycode);
            handleMenuClose();
            setLoanType('real')
          }}
          disabled={selectedRow?.loanlimits?.optin == "0" ? true : false}
        >
          Create Real Time Loan
        </MenuItem> */}

        {/* <MenuItem
          onClick={() => {
            setSelectedProductLoan(selectedRow?.loanlimits);
            setViewCancelledLoans(true);
            handleMenuClose();
          }}
          disabled={selectedRow?.loanlimits?.optin == "0" ? true : false}
        >
          Cancelled Requests
        </MenuItem> */}

        <MenuItem
          onClick={() => {
            setSelectedProductLoan(selectedRow?.loanlimits);
            setViewPreQualificationScreening(true);
            handleMenuClose();
          }}
        >
          Pre-Qualification / Screening
        </MenuItem>

        <MenuItem
          onClick={() => {
            setSelectedProductLoan(selectedRow?.loanlimits);
            setViewUnderwritingCreditAssessment(true);
            handleMenuClose();
          }}
        >
          Underwriting & Credit Assessment
        </MenuItem>

        <MenuItem
          onClick={() => {
            setSelectedProductLoan(selectedRow?.loanlimits);
            setViewApprovalLoanRequest(true);
            handleMenuClose();
          }}
        >
          Approval
        </MenuItem>

        {/* <MenuItem
          onClick={() => {
            setSelectedProductLoan(selectedRow?.loanlimits);
            setViewLoanRequestDisbursement(true);
            handleMenuClose();
          }}
        >
          Disburse Loans
        </MenuItem> */}

        <MenuItem
          onClick={() => {
            handleApprovedLoans(selectedRow?.loanproducts);
            setSelectedProductLoan(selectedRow?.loanlimits);
            handleMenuClose();
          }}
        >
          Disbursed Loans
        </MenuItem>

        <MenuItem
          onClick={() => {
            handleApproveLoans(selectedRow?.loanproducts);
            setSelectedProductLoan(selectedRow?.loanlimits);
            handleMenuClose();
          }}
          disabled={selectedRow?.loanlimits?.optin == "0" ? true : false}
        >
          Loan Requests
        </MenuItem>

        <MenuItem
          onClick={() => {
            // setSelectedProductLoan(selectedRow?.loanproducts);
            setSelectedProductLoan(selectedRow?.loanlimits);
            setPayments(true);
            handleMenuClose();
          }}
          disabled={selectedRow?.loanlimits?.optin == "0" ? true : false}
        >
          Make Payments
        </MenuItem>

        <MenuItem
          onClick={() => {
            // setSelectedProductLoan(selectedRow?.loanproducts);
            setSelectedProductLoan(selectedRow?.loanlimits);
            setViewPayments(true);
            handleMenuClose();
          }}
        >
          View User Payments
        </MenuItem>

        <MenuItem
          onClick={() => {
            // setSelectedProductLoan(selectedRow?.loanproducts);
            setSelectedProductLoan(selectedRow?.loanlimits);
            setViewCancelPayments(true);
            handleMenuClose();
          }}
        >
          Cancel Payments
        </MenuItem>

        <MenuItem
          onClick={() => {
            setNewLimit(selectedRow?.loanlimits?.eligiblelimit)
            setEditLimitModal(true)
            // handleMenuClose();
          }}
        >
          Edit Limit
        </MenuItem>

        <MenuItem
          onClick={() => {
            setSelectedProductLoan(selectedRow?.loanlimits);
            setViewLimitHistory(true);
            handleMenuClose();
          }}
        >
          View Limit History
        </MenuItem>

        {/* <MenuItem
          onClick={() => {
            setLoanAssignment(true);
            handleMenuClose();
          }}
        >
          Loan Assignments
        </MenuItem> */}

        <MenuItem
          onClick={() => {
            setSelectedLoanProduct(selectedRow);
            // setOpenDetailsDialog(true);
            setOpenDetailsDrawer(true);
            handleMenuClose();
          }}
        >
          View Details
        </MenuItem>

        <MenuItem
          onClick={() => {
            handleMoreInfo(selectedRow?.loanlimits);
            handleMenuClose();
          }}
        >
          View More Info
        </MenuItem>

        <MenuItem
          onClick={() => {
            handleLoanOptIn(selectedRow?.loanlimits);
            handleMenuClose();
          }}
        >
          Opt In
        </MenuItem>

        <MenuItem
          onClick={() => {
            handleLoanOptOut(selectedRow?.loanlimits);
            handleMenuClose();
          }}
          disabled={selectedRow?.loanlimits?.optin == "0" ? true : false}
        >
          Opt Out
        </MenuItem>
      </Menu>

      <Modal open={editLimitModal} onClose={() => setEditLimitModal(false)}>
          <Box
              sx={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  width: 400,
                  bgcolor: "background.paper",
                  p: 3,
                  borderRadius: "10px",
                  boxShadow: 24,
              }}
          >
            <Box className="d-flex justify-content-between">
              <Typography variant="h6" gutterBottom>
                Update Loan Limit    
              </Typography>
              <Box sx={{ position: "absolute", top: 8, right: 8, width: 40, height: 40 }}>
                <IconButton onClick={() => setEditLimitModal(false)} sx={{ zIndex: 1, color: "#6c757d", "&:hover": { color: "#000" } }}>
                    <CloseIcon />
                </IconButton>
              </Box>
            </Box>

              {/* Input Field for Setting Limit */}
              {/* <TextField
                  fullWidth
                  label="Set New Limit"
                  type="number"
                  className="mt-2"
                  value={newLimit}
                  // onChange={(e) => setCustomAmount(e.target.value)}
                  onChange={(e) => {
                      setNewLimit(e.target.value);
                  }}
                  sx={{ mb: 2 }}
              /> */}

              {/* Input Field adding comment/reason */}
              {/* <TextField
                fullWidth
                label="Comment"
                type="text"
                className="mt-2"
                value={comment}
                // onChange={(e) => setCustomAmount(e.target.value)}
                onChange={(e) => {
                    setComment(e.target.value);
                }}
                sx={{ mb: 2 }}
              /> */}

              {/* <Button variant="contained" color="primary" fullWidth onClick={handleEditLoanLimit}>
                  Update
              </Button> */}

              <CustomLoansForm
                formValues={formValues}
                formName={"updateloanlimit"}
                buttonText={"Submit"}
                onSubmit={handleEditLoanLimit}
                loadingButtonText={"Updating Loan Limit ..."}
              />
          </Box>
      </Modal>

      <div className="loans-details-info-drawer">
        <BaseDrawer
            open={openDetailsDrawer}
            handleClose={() => setOpenDetailsDrawer(false)}
            height="85vh"
            className="loanProductInfoDrawer"
            overflow="auto"
        >
          {selectedLoanProduct?.loanlimits && (
              <Box>
                <Box className="user-accounts-tab">
                    <Box className="balance-container">
                        <Box className="row" display="flex" flexWrap="wrap" gap={4}>
                            {/* Left Column - Loan Limits Info */}
                            <Box minWidth="300px" flex={1}>
                                <Typography sx={{ fontWeight: 800, color: "#6b7280", fontFamily: "Nunito", fontSize: "16px" }}>
                                    Loan Limit Info
                                </Typography>
                                {[
                                    { label: "User ID", value: selectedLoanProduct?.loanlimits.userid },
                                    { label: "Product Code", value: selectedLoanProduct?.loanlimits.productcode },
                                    { label: "Eligible Limit", value: selectedLoanProduct?.loanlimits.eligiblelimit },
                                    { label: "Status", value: selectedLoanProduct?.loanlimits.status },
                                    { label: "Loan Enabled by User", value: selectedLoanProduct?.loanlimits.loanenabledbyuser },
                                    { label: "Last Update Time", value: selectedLoanProduct?.loanlimits.lastupdatetime },
                                    { label: "Opt-in", value: selectedLoanProduct?.loanlimits.optin == 1 ? "Yes" : "No" },
                                    { label: "Opt-in Date", value: selectedLoanProduct?.loanlimits.optindate },
                                    { label: "Opt-out Date", value: selectedLoanProduct?.loanlimits.optoutdate },
                                    { label: "Opt-in Ref No", value: selectedLoanProduct?.loanlimits.optinrefno },
                                    { label: "Opt-out Ref No", value: selectedLoanProduct?.loanlimits.optoutrefno },
                                    { label: "Loan Issued Count", value: selectedLoanProduct?.loanlimits.loanissuedcount },
                                    { label: "Total Outstanding Late Fees", value: selectedLoanProduct?.loanlimits.totaloutstandinglatefees },
                                    { label: "Unconfirmed Amount", value: selectedLoanProduct?.loanlimits.unconfirmedamount },
                                    { label: "Bank Code", value: selectedLoanProduct?.loanlimits.bankcode },
                                    { label: "Block Date", value: selectedLoanProduct?.loanlimits.blockdate }, 
                                ].map(({ label, value }, index) => (
                                    <Box className="info-container" key={index}>
                                        <Box className="info-type">{label}:</Box>
                                        <Box className="info-response">{value || "N/A"}</Box>
                                    </Box>
                                ))}
                            </Box>

                            {/* Right Column - Product Info */}
                            <Box minWidth="300px" flex={1}>
                                <Typography sx={{ fontWeight: 800, color: "#6b7280", fontFamily: "Nunito", fontSize: "16px" }}>
                                    Product Info
                                </Typography>
                                {[
                                    { label: "Product Name", value: selectedLoanProduct?.loanproducts?.productname },
                                    { label: "Currency Code", value: selectedLoanProduct?.loanproducts?.currencycode },
                                ].map(({ label, value }, index) => (
                                    <Box className="info-container" key={index}>
                                        <Box className="info-type">{label}:</Box>
                                        <Box className="info-response">{value || "N/A"}</Box>
                                    </Box>
                                ))}
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Box>
          )}
        </BaseDrawer>
      </div>

      <Dialog
          open={openDetailsDialog}
          onClose={() => setOpenDetailsDialog(false)}
          fullWidth
          maxWidth="md"
          className="loans-dialog"
      >
          <DialogTitle>
              <Box>
                  Loan Limit Details
                  <Box sx={{ position: "absolute", top: 8, right: 8, width: 40, height: 40 }}>
                      <IconButton onClick={() => setOpenDetailsDialog(false)} sx={{ zIndex: 1, color: "#6c757d", "&:hover": { color: "#000" } }}>
                          <CloseIcon />
                      </IconButton>
                  </Box>
              </Box>
          </DialogTitle>
          <DialogContent dividers>
              {selectedLoanProduct?.loanlimits && (
                  <Box>
                      <Box className="user-accounts-tab">
                          <Box className="balance-container">
                              <Box className="row" display="flex" flexWrap="wrap" gap={4}>
                                  {/* Left Column - Loan Limits Info */}
                                  <Box minWidth="300px" flex={1}>
                                      <Typography sx={{ fontWeight: 800, color: "#6b7280", fontFamily: "Nunito", fontSize: "16px" }}>
                                          Loan Limit Info
                                      </Typography>
                                      {[
                                          { label: "User ID", value: selectedLoanProduct?.loanlimits.userid },
                                          { label: "Product Code", value: selectedLoanProduct?.loanlimits.productcode },
                                          { label: "Eligible Limit", value: selectedLoanProduct?.loanlimits.eligiblelimit },
                                          { label: "Status", value: selectedLoanProduct?.loanlimits.status },
                                          { label: "Loan Enabled by User", value: selectedLoanProduct?.loanlimits.loanenabledbyuser },
                                          { label: "Last Update Time", value: selectedLoanProduct?.loanlimits.lastupdatetime },
                                          { label: "Opt-in", value: selectedLoanProduct?.loanlimits.optin },
                                          { label: "Opt-in Date", value: selectedLoanProduct?.loanlimits.optindate },
                                          { label: "Opt-out Date", value: selectedLoanProduct?.loanlimits.optoutdate },
                                          { label: "Opt-in Ref No", value: selectedLoanProduct?.loanlimits.optinrefno },
                                          { label: "Opt-out Ref No", value: selectedLoanProduct?.loanlimits.optoutrefno },
                                          { label: "Loan Issued Count", value: selectedLoanProduct?.loanlimits.loanissuedcount },
                                          { label: "Total Outstanding Late Fees", value: selectedLoanProduct?.loanlimits.totaloutstandinglatefees },
                                          { label: "Unconfirmed Amount", value: selectedLoanProduct?.loanlimits.unconfirmedamount },
                                          { label: "Bank Code", value: selectedLoanProduct?.loanlimits.bankcode },
                                          { label: "Block Date", value: selectedLoanProduct?.loanlimits.blockdate }, 
                                      ].map(({ label, value }, index) => (
                                          <Box className="info-container" key={index}>
                                              <Box className="info-type">{label}:</Box>
                                              <Box className="info-response">{value || "N/A"}</Box>
                                          </Box>
                                      ))}
                                  </Box>

                                  {/* Right Column - Product Info */}
                                  <Box minWidth="300px" flex={1}>
                                      <Typography sx={{ fontWeight: 800, color: "#6b7280", fontFamily: "Nunito", fontSize: "16px" }}>
                                          Product Info
                                      </Typography>
                                      {[
                                          { label: "Product Name", value: selectedLoanProduct?.loanproducts?.productname },
                                          { label: "Currency Code", value: selectedLoanProduct?.loanproducts?.currencycode },
                                      ].map(({ label, value }, index) => (
                                          <Box className="info-container" key={index}>
                                              <Box className="info-type">{label}:</Box>
                                              <Box className="info-response">{value || "N/A"}</Box>
                                          </Box>
                                      ))}
                                  </Box>
                              </Box>
                          </Box>
                      </Box>
                  </Box>
              )}
          </DialogContent>
          <DialogActions>
              <Button onClick={() => setOpenDetailsDialog(false)} color="primary">
                  Close
              </Button>
          </DialogActions>
      </Dialog>
    </Box>
  );
};

export default LoanProductsAssignedTable;
